import React from 'react';
import { MathsBadge } from '../shared/MathsBadge';
export function AboutEediSection() {
  return <section className="py-16 bg-gray-50" id="about-eedi" data-id="element-81">
      {/* Visual divider at the top of the section */}
      <div className="relative mb-16" data-id="element-82">
        <div className="absolute inset-0 flex items-center" data-id="element-83">
          <div className="w-full border-t border-gray-300" data-id="element-84"></div>
        </div>
        <div className="relative flex justify-center" data-id="element-85">
          <div className="px-4 bg-gray-50" data-id="element-86">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center shadow-md" data-id="element-87">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-88">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" data-id="element-89"></path>
                <path d="m7 10 5 5 5-5" data-id="element-90"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4" data-id="element-91">
        <div className="max-w-4xl mx-auto" data-id="element-92">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-93">
            About Eedi
          </h2>
          <p className="text-lg text-gray-700 mb-10" data-id="element-94">
            Eedi is a research-backed maths platform helping over 15,000
            teachers worldwide uncover pupil misconceptions, deliver targeted
            support, and reduce workload.
          </p>
          {/* Mission statement with enhanced visibility */}
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-8 rounded-xl border-l-4 border-purple-600 mb-10 relative" data-id="element-95">
            <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hrz8WCxBsxSDCsr4NXoNd9/Cat.png" altText="Math Cat Badge" size="medium" className="absolute -top-6 -left-6 z-20 hidden md:block" data-id="element-96" />
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-97">
              <div className="md:w-1/2" data-id="element-98">
                <p className="text-xl font-bold text-gray-800" data-id="element-99">
                  We're building on existing evidence: Students using Eedi made
                  +2 months of progress in maths in comparison to students who
                  didn't use Eedi.
                </p>
              </div>
              <div className="md:w-1/2" data-id="element-100">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c45wh3vDSFqMYpn7o13diE/RCT_y2_front_page.png" alt="Eedi Impact Report showing +2 months progress" className="rounded-lg shadow-md" data-id="element-101" />
              </div>
            </div>
            <MathsBadge imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/k9qfpEeMdg27tDko21ZZB8/Donut.png" altText="Math Donut Badge" size="medium" className="absolute -bottom-6 -right-6 z-20 hidden md:block" data-id="element-102" />
          </div>
          <h3 className="text-xl font-semibold mb-6 mt-10" data-id="element-103">
            Our work is built on three core principles:
          </h3>
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-104">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-105">
              <h4 className="font-bold text-lg mb-2 text-purple-700" data-id="element-106">
                Learning Engineering
              </h4>
              <p className="text-gray-700" data-id="element-107">
                We partner with experts at leading institutions like Cambridge
                and Stanford to develop and validate our advanced models.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-108">
              <h4 className="font-bold text-lg mb-2 text-blue-700" data-id="element-109">
                Intelligent Technology
              </h4>
              <p className="text-gray-700" data-id="element-110">
                Our platform uses high-quality expert-authored diagnostic
                questions and personalised interventions to identify and resolve
                student misconceptions.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-111">
              <h4 className="font-bold text-lg mb-2 text-indigo-700" data-id="element-112">
                Proven Efficacy
              </h4>
              <p className="text-gray-700" data-id="element-113">
                Our impact is verified by rigorous research. An independent
                Randomised Controlled Trial (RCT) found students using Eedi
                achieved an additional 2-3 months of maths progress within a
                year.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}